/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch, Action, AnyAction } from 'redux';
import { all, fork } from 'redux-saga/effects';
import { ConfigState } from './config/types';
import { ConfigSaga } from './config/sagas';
import { CeclApiState } from './ceclapi/types';
import { CeclApiSaga } from './ceclapi/sagas';
import { UserManagementSaga } from './user-management/sagas';
import { UserManagementState } from './user-management/types';

export interface ApplicationState {
    config: ConfigState;
    cecl: CeclApiState;
    lastAction: LastAction;
    userManagement: UserManagementState
}
export interface LastAction {
    type: string;
    payload: any;
    meta: any;
    error: any;
}
export interface ConnectedReduxProps<A extends Action = AnyAction> {
    dispatch: Dispatch<A>;
}

export const lastAction = (action: any) => {
    return action;
};

export function* RootSaga() {
    yield all([fork(ConfigSaga), fork(CeclApiSaga), fork(UserManagementSaga)]);
}
